<template>
    <div class="input-component">
        <label :for="id">{{label}}</label>
        <input :id="id" autocomplete="off" type="text" @input="$emit('input', $event.target.value)">
        <i class="bar"></i>
    </div>
</template>

<script>
    export default {
        name: "inputComponent",
        props:{
          id:{type:String},
          label:{type: String}
        },
        data(){
            return{

            }
        }
    }

</script>

<style scoped>
    label{
        font-weight: bold;
    }
</style>
